import React, { useEffect } from "react";
import { Form, Input, InputNumber, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import {
  getRewardDetails,
  doRewardCreate,
  doRewardUpdate,
} from "../../../../redux/reward/rewardState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { USABLE_ICONS, COLOR_OPTIONS } from "../../../../variables/constants"; 

const RewardForm = ({
  recordData,
  getRecord,
  doCreate,
  doUpdate,
  onCancel,
  submitLabel,
  ...props
}) => {
  const [form] = Form.useForm();
  const { recordId, mode } = props;

  useEffect(() => {
    if (recordId) getRecord(recordId);
  }, [recordId, getRecord]);

  useEffect(() => {
    if (recordData) {
      form.resetFields();
      const initialValues = {
        rwd_id: recordData?.rwd_id ?? "",
        rwd_title: recordData?.rwd_title ?? "",
        rwd_description: recordData?.rwd_description ?? "",
        rwd_icon: recordData?.rwd_icon ?? "",
        rwd_color_class: recordData?.rwd_color_class ?? "",
        rwd_points: recordData?.rwd_points ?? "",
      };
      form.setFieldsValue(initialValues);
    }
  }, [recordData, form]);

  const onSubmit = (formData) => {
    try {
      recordData?.rwd_id > 0 ? doUpdate(formData) : doCreate(formData);
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      className={mode !== "view" ? "form" : ""}
    >
      <FormItem name="rwd_id" hidden>
        <Input type="hidden" />
      </FormItem>

      <div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">
        <FormItem
          name="rwd_title"
          label="Award Title"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <Input
              id="rwd_title"
              placeholder="Enter award title"
              className="input-field"
              maxLength={100}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.rwd_title}
            </label>
          )}
        </FormItem>

        <FormItem
          name="rwd_description"
          label="Description"
          rules={[requiredField]}
          className="col-span-2"
        >
          {mode !== "view" ? (
            <Input
              placeholder="Enter description"
              className="input-field"
              maxLength={300}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.rwd_description}
            </label>
          )}
        </FormItem>

        <FormItem
          name="rwd_icon"
          label="Icon"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <Select
              placeholder="Select icon"
              className="input-field"
              showSearch
              allowClear
              options={Object.keys(USABLE_ICONS).map((key) => ({
                label: key,
                value: key,
              }))}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.rwd_icon}
            </label>
          )}
        </FormItem>

        <FormItem
          name="rwd_color_class"
          label="Color"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <Select
              placeholder="Select color"
              className="input-field"
              options={COLOR_OPTIONS}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.rwd_color_class}
            </label>
          )}
        </FormItem>

        <FormItem
          name="rwd_points"
          label="Points"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <InputNumber
              placeholder="Set points"
              className="input-field"
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.rwd_points}
            </label>
          )}
        </FormItem>
      </div>

      <div className="w-full flex justify-end">
        {(mode === "edit") && (
          <CrudButtons
            mode={mode}
            recordId={recordData?.rwd_id ?? 0}
            isModal={true}
            modalId={recordData?.rwd_id > 0 ? "edit_reward" : "add_reward"}
            cancelLabel="Cancel"
            viewMode="modal"
            doHideModal={onCancel}
            submitLabel={submitLabel}
          />
        )}
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.reward.rewardDetails?.data, 
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getRewardDetails(id)),
  doCreate: (data) => dispatch(doRewardCreate(data)),
  doUpdate: (data) => dispatch(doRewardUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardForm);
